import { useState } from "react";

import { DownloadBundle, DownloadPart, Maybe } from "../../graphql/types";
import { DownloadRow } from "../DownloadRow";

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { DateCol, StatusTh } from "../ui/muiTables";

const toRows = (bundles: Array<DownloadBundle> | null) => {
  const downloadFiles: Array<{
    bundle: DownloadBundle;
    part: Maybe<DownloadPart>;
  }> = [];
  bundles?.forEach((bundle) => {
    if (bundle.parts) {
      bundle.parts.forEach((part) => {
        downloadFiles.push({ bundle, part });
      });
    } else {
      // In progress downloads have no parts
      downloadFiles.push({ bundle, part: null });
    }
  });
  return downloadFiles;
};

export const DownloadTable = ({ bundles = null }: { bundles?: DownloadBundle[] | null }) => {
  const [rowSelected, setRowSelected] = useState<string | number | null>(null);

  const handleRowSelected = (id: string) => {
    if (id && id === rowSelected) {
      setRowSelected(null);
    } else {
      setRowSelected(id);
    }
  };

  const downloadRows = toRows(bundles);
  const rows = downloadRows.map((d) => {
    if (d.part) {
      return (
        <DownloadRow
          key={d.part.id}
          allowViewUploads={true}
          onClick={handleRowSelected}
          bundle={d.bundle}
          part={d.part}
          purpose={d.bundle.purpose}
          showDetail={rowSelected === d.part.id}
          sourceTable={d.part.source_table}
        />
      );
    } else {
      const sourceTable = d.bundle.source_tables.length > 0 ? d.bundle.source_tables[0] : null;
      return (
        <DownloadRow
          key={d.bundle.id}
          allowViewUploads={true}
          onClick={handleRowSelected}
          bundle={d.bundle}
          purpose={d.bundle.purpose}
          showDetail={rowSelected === d.bundle.id}
          sourceTable={sourceTable}
        />
      );
    }
  });

  return (
    <TableContainer component={Paper} sx={{ width: "100%", minWidth: "fit-content" }}>
      <Table
        className="table-striped table-condensed"
        stickyHeader
        data-cy="downloads-table"
        data-testid="downloads-table"
      >
        <TableHead>
          <TableRow>
            <DateCol>Report Date</DateCol>
            <DateCol>Found</DateCol>
            <DateCol>Started</DateCol>
            <DateCol>Finished</DateCol>
            <TableCell>Description</TableCell>
            <TableCell></TableCell>
            <StatusTh>Status</StatusTh>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
};
